import { Component, computed, effect, inject, OnInit, signal } from '@angular/core';
import { BasicDialogComponent } from 'src/app/BaseDialog/basic-dialog/basic-dialog.component';
import { DialogItem } from 'src/app/dialog-item';
import { LinkedBusinessListComponent } from 'src/app/linked-business-list/linked-business-list.component';
import { MatTableController } from 'src/app/mat-table-controller';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Business } from 'src/model/business';
import { FinanceAccount } from 'src/model/financeAccount.model';
import { BusinessService } from 'src/services/business.service';
import { FinanceAccountService } from 'src/services/finance-account.service';
import { AddFinanceAccountComponent } from '../add-finance-account/add-finance-account.component';

@Component({
  selector: 'app-finance-account-list',
  standalone: false,
  templateUrl: './finance-account-list.component.html',
  styleUrl: './finance-account-list.component.scss',
  providers: [MatTableController]
})
export class FinanceAccountListComponent implements OnInit {
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  protected table = inject(MatTableController<FinanceAccount>);
  private faService = inject(FinanceAccountService);
  private businessService = inject(BusinessService);

  searchText = signal<string>('');
  faList = signal<FinanceAccount[]>([]);
  filteredFaList = computed(() => {
    const fa = this.faList();
    console.log(fa);
    return fa?.length > 0 ? this.showActive() !== this.showDisabled() ? fa.filter(f => f.Disabled === this.showDisabled()) : fa : [];
  });
  businessList = signal<Business[]>([]);
  displayedColumns = computed(() => [...this.table.columnDefs(), 'Action']);

  showActive = signal(true);
  showDisabled = signal(false);

  constructor() {
    this.table.config.set([
      { columnDef: 'Code', header: 'Code' },
      { columnDef: 'Bank', header: 'Bank' },
      { columnDef: 'AccNumber', header: 'Account No.' },
      { columnDef: 'Description', header: 'Description' },
      { columnDef: 'Directors', header: 'Directors' },
      { columnDef: 'Businesses', header: 'Linked Businesses', calculated: (row => row.BusinessIds ? row.BusinessIds.length : 0 ), onClick: (row => this.openLinkedBusinesses(row)) },
    ]);
    this.table.paginationEnabled.set(true);
    this.table.pageSize.set(100);

    effect(() => {
      this.table.rawData.set([{ items: this.filteredFaList() }]);
    });

    effect(() => {
      this.table.filterQuery.set(this.searchText());
    });
  }

  ngOnInit() {
    this.getData();
  }

  async getData() {
    const [f, b] = await Promise.all([
      this.faService.getAllFinanceAccounts(),
      this.businessService.getAllBusinesses()
    ]);
    this.faList.set(f.sort((a, b) => a.Id - b.Id));
    this.businessList.set(b);
  }

  openAddFAModal() {
    const modalRef = this.sharedService.openModal(AddFinanceAccountComponent);
    modalRef.componentInstance.passEntry.subscribe((account: FinanceAccount) => {
      this.faList.update(list => [...list, account]);
    });
  }

  async updateFinanceAccount(fa: FinanceAccount) {
    const modalRef = this.sharedService.openModal(AddFinanceAccountComponent);
    modalRef.componentInstance.isEdit = true;
    modalRef.componentInstance.faToUpdate = fa;
    modalRef.componentInstance.passEntry.subscribe((updatedFA: FinanceAccount) => {
      this.faList.update(list => {
        const i = list.findIndex(a => a.Id === updatedFA.Id);
        list.splice(i, 1, updatedFA);
        return [...list];
      })
    });
  }

  disableFinanceAccount(fa: FinanceAccount, index: number) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = `Do you want to disable this account?\n [${fa.Code}] ${fa.Description} ${fa.AccNumber}`;
    modalRef.result.then(async confirm => {
      if (confirm) {
        await this.faService.disableFinanceAccount(fa.Id);
        this.faList.update(list => list.map(l => l.Id === fa.Id ? Object.assign(new FinanceAccount, fa, { Disabled: true }) : l));
      }
    });
  }

  openLinkedBusinesses(fa: FinanceAccount) {
    const modalRef = this.sharedService.openModal(BasicDialogComponent);
    const i = modalRef.componentInstance as BasicDialogComponent;
    i.title = 'Linked Businesses';
    i.autoFocus = false;
    i.injectContent = [new DialogItem(LinkedBusinessListComponent, { fa: fa, allBusinessList: this.businessList() })];
    i.data$.subscribe(res => {
      this.faList.update(list => {
        const f = list.find(a => a.Id === res.Id);
        f.BusinessIds = res.BusinessIds;
        return [...list];
      })
    });
  }
}
